import { Pipe, PipeTransform } from '@angular/core';
import { CustomDesignPage } from '../../../admin360/customization/models/custom-design-page.model';

@Pipe({
  name: 'cstUserDesignPagesByID'
})
export class CstUserDesignPagesByIDPipe implements PipeTransform {

  transform(designPageId: number, designPages: CustomDesignPage[]): CustomDesignPage[] {
    return designPages.filter(p => !p.BasePage && p.DesignPageID == designPageId);
  }

}
